import constate from 'constate';
import { useParams } from 'react-router-dom';

import { useAgentApi } from '../common/useAgentApi';

function useAgentDetails() {
  const { agentId } = useParams<{ agentId: string }>();
  const { agentResponse, updateAgentMutation, agentPermissions } = useAgentApi({ agentId });

  return {
    agentId,
    agentResponse,
    updateAgentMutation,
    agentPermissions,
  };
}

export const [AgentDetailsProvider, useAgentDetailsContext] = constate(useAgentDetails);
